import { Link } from '@tanstack/react-router';

/** Shared 404 page — used in both the root and authenticated layout not-found slots. */
export function NotFound() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-muted-foreground text-sm">Page not found</p>
      <Link to="/" className="text-primary text-sm underline">
        Go home
      </Link>
    </div>
  );
}
